//ChartJS
import { Chart } from 'chart.js';
//Helpers
import { fontString } from 'chart.js/helpers';
import { convert } from '../../../../helpers/utilities';
//Types
import type { ArcProps } from 'chart.js';
import type { PieLabelsConfig } from '../../../../types/Chart';

export default {
	beforeInit: (chart) => {
		const config = chart.options.plugins?.pieLabels;
		if (config) {
			chart.pieLabels = new PieLabels(config);
		}
	},
	afterDatasetsDraw: (chart) => {
		if (chart.pieLabels && chart.config.data.datasets[0]) {
			chart.pieLabels.draw(chart);
		}
	},
};

class PieLabels {
	private config: PieLabelsConfig;
	constructor(config: PieLabelsConfig) {
		this.config = {
			shadowBlur: 2,
			shadowOffsetX: 1,
			shadowOffsetY: 1,
			shadowColor: 'rgba(0,0,0,0.5)',
			color: Chart.defaults.color as string,
			fontSize: Chart.defaults.font.size,
			fontFamily: Chart.defaults.font.family,
			fontStyle: '600',
			units: 'W',
			...config,
		};
	}
	public draw(chart: Chart<'pie'>) {
		if (!chart?.tooltip) return;
		chart.tooltip.opacity = 0;
		const ctx: CanvasRenderingContext2D = chart.ctx,
			meta = chart.getDatasetMeta(0),
			labels = chart.data.datasets[0].data;
		ctx.save();
		ctx.textBaseline = 'middle';
		ctx.fillStyle = this.config.color;
		ctx.shadowBlur = this.config.shadowBlur;
		ctx.shadowColor = this.config.shadowColor;
		ctx.shadowOffsetX = this.config.shadowOffsetX;
		ctx.shadowOffsetY = this.config.shadowOffsetY;
		for (let i = 0; i < meta.data.length; ++i) {
			const view: ArcProps = meta.data[i] as any,
				circumference = this.degrees(view.circumference);
			if (circumference < 20) continue;
			ctx.font = fontString(
				this.config.fontSize + (view?.['active'] ? 0.5 : 0),
				this.config.fontStyle,
				this.config.fontFamily,
			);
			const maxDistance = 1.2,
				defDistance = 1.5,
				distance =
					circumference > 30
						? defDistance
						: this.normalize((circumference / 30) * defDistance, maxDistance, defDistance),
				angle = view.startAngle + (view.endAngle - view.startAngle) / 2,
				label = convert(labels[i], this.config.units);
			let labelX =
					view.x +
					(view.outerRadius / distance) * Math.cos(angle) -
					Math.abs(ctx.measureText(label).width / 2),
				labelY = view.y + (view.outerRadius / distance) * Math.sin(angle);
			ctx.fillText(label.toString(), labelX, labelY);
		}
		ctx.restore();
	}
	private degrees(radians: number) {
		return (radians * 180) / Math.PI;
	}
	private normalize(n: number, min = 0, max = 1) {
		return n < min ? min : n > max ? max : n;
	}
}
